import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Calculatrice un tiers - Calculez un tiers du nombre";
const DESCRIPTION =
  "Calculatrice un tiers - Calculez un tiers du nombre pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "un tiers un tiers du nombre, calculatrice un tiers un tiers du nombre, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/onethird-calculator/";
function OneThirdCalculator() {
  const [number, setNumber] = useState();
  const [result, setResult] = useState();
  const [error, setError] = useState("");
  const [steps, setSteps] = useState("");
  const handleCalculate = () => {
    try {
      if (number) {
        const oneThird = parseFloat(number / 3).toFixed(2);
        setResult(oneThird);
        setSteps(`Pour calculer un tiers du nombre ${number}:
        \n1. Nous divisons le nombre par 3: ${number} ÷ 3 = ${oneThird}`);
        setError("");
      } else {
        setError("Veuillez entrer un nombre pour effectuer le calcul!");
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule un tiers de n'importe quel nombre. Pour effectuer le calcul, nous appliquons l'équation suivante: un tiers du nombre = Nombre / 3.
                </p>
                <p>Pour calculer un tiers d'un nombre, suivez les étapes suivantes:</p>
                <ul>
                  <li>Entrez le nombre dont vous souhaitez calculer un tiers dans le champ désigné.</li>
                  <li>Cliquez sur le bouton "Calculer".</li>
                </ul>
                <p>
                  Cette calculatrice a été développée pour être facile à utiliser et utile pour les personnes qui ont besoin de calculer un tiers d'un nombre rapidement et avec précision.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div className="ltr">
                  <div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                      <b>
                        <label className="form-label me-2" htmlFor="number">
                          Entrez le nombre
                        </label>
                      </b>
                      <input
                        id="number"
                        type="number"
                        value={number}
                        onChange={(e) => setNumber(e.target.value)}
                        placeholder="Entrez le nombre"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginRight: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer
                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-dark">
                      Erreur : {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className=" text-white">Résultat:</h4>
                      <p className="text-white">{result}</p>
                      <div
                        className="p-3 mb-2 bg-info text-dark"
                        style={{ width: "100%" }}
                      >
                        <h4 style={{ color: "black" }}>Étapes de la solution:</h4>
                        <p
                          className="text-dark"
                          style={{ whiteSpace: "pre-line" }}
                        >
                          {steps}
                        </p>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Calculatrice du tiers (1/3)</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        <strong>Qu'est-ce que la calculatrice du tiers ?</strong>
                        Cet outil calcule le tiers (1/3) d'un nombre en appliquant
                        une formule simple : résultat = nombre ÷ 3.
                      </p>
                      <p>
                        <strong>Comment utiliser :</strong>
                        Entrez le nombre dans le champ prévu, puis appuyez sur "Calculer".
                      </p>
                      <p>
                        <strong>Exemples :</strong>
                        Réduire une recette à un tiers des ingrédients,
                        partager un montant en trois parts égales,
                        résoudre des problèmes mathématiques impliquant 1/3.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default OneThirdCalculator;
